/* eslint-disable */
// Here eslint disable is use to avoid line width error
import React from "react";

const WorkLuggage = (props: { className?: string }) => (
  <svg
    {...props}
    id="portfolio"
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
  >
    <path
      id="Tracé_5"
      data-name="Tracé 5"
      d="M17.242,7.517H13.724V5.172A1.172,1.172,0,0,0,12.552,4H7.862A1.172,1.172,0,0,0,6.69,5.172V7.517H3.172A1.172,1.172,0,0,0,2,8.69V16.9a1.172,1.172,0,0,0,1.172,1.172H17.242A1.172,1.172,0,0,0,18.414,16.9V8.69A1.172,1.172,0,0,0,17.242,7.517ZM7.862,5.172h4.69V7.517H7.862ZM3.172,16.9V8.69H17.242V16.9Z"
      transform="translate(-0.828 -1.655)"
      fill="#f4f4fc"
    />
    <rect
      id="_Transparent_Rectangle_"
      data-name="&lt;Transparent Rectangle&gt;"
      width="19"
      height="19"
      fill="none"
    />
  </svg>
);

export { WorkLuggage };
